import React, { CSSProperties, FC, ImgHTMLAttributes } from 'react'

import cn from 'classnames'

import classes from './icon.module.scss'

interface IconProps extends ImgHTMLAttributes<HTMLImageElement> {
  margin?: string
}

export const Icon: FC<IconProps> = ({
  width,
  height,
  margin,
  className,
  style,
  ...rest
}) => (
  <img
    alt=""
    className={cn(classes.icon, className)}
    style={
      {
        ...style,
        '--icon-width': width,
        '--icon-height': height,
        '--icon-margin': margin,
      } as CSSProperties
    }
    {...rest}
  />
)

export default Icon
